import { useSelector } from 'react-redux';
/**
 * Get the UI version from the store
 *
 * The UI version is an integer incremented by the refresh button;
 * it serves to force running fetch hooks again.
 */
var useVersion = function () {
    return useSelector(function (reduxState) { return reduxState.admin.ui.viewVersion; });
};
export default useVersion;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/controller/useVersion.js
// module id = 167
// module chunks = 0